export const DISPLAY_TABS = {
    'ACTUAL_PRICE': 'Actual',
    'LIST_PRICE': 'List'
}

export const RETAILER_DISPLAY_TABS = {
    'CURRENT_PRICE': 'Current',
    'LIST_PRICE': 'List'
}